import i18next from 'i18next';

/**
 * The `Intl` locale dates are written in: the UI language's (ADR 0049). Danish
 * reads "8. okt. 2026", English "8 Oct 2026". Numbers are NOT routed here —
 * they stay `da-DK` in both languages (BR-15).
 *
 * Reads i18next's own state rather than importing the app's i18n module, so
 * `lib/` stays free of app wiring; uninitialised (unit tests) means English.
 */
export const dateLocale = (): 'da-DK' | 'en-GB' =>
  i18next.language?.startsWith('da') ? 'da-DK' : 'en-GB';

/**
 * `Intl.DateTimeFormat` construction is expensive and these are called per
 * row, so one instance per (locale, options) — created on first use.
 */
export const cachedDateFormat = (
  options: Intl.DateTimeFormatOptions,
): (() => Intl.DateTimeFormat) => {
  const byLocale = new Map<string, Intl.DateTimeFormat>();
  return () => {
    const locale = dateLocale();
    let format = byLocale.get(locale);
    if (!format) {
      format = new Intl.DateTimeFormat(locale, options);
      byLocale.set(locale, format);
    }
    return format;
  };
};
